import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './OrganizerLanding.css';

const OrganizerNavbar = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="organizer-navbar">
      <div className="organizer-navbar-container">
        <div className="organizer-navbar-logo" onClick={() => navigate('/organizer')}>
          <h2>PersonaX</h2>
        </div>
        
        <div className={`organizer-navbar-links ${isMenuOpen ? 'open' : ''}`}>
          <div className="organizer-nav-link" onClick={() => navigate('/organizer')}>
            Home
          </div>
          <div className="organizer-nav-link" onClick={() => {
            const featuresSection = document.querySelector('.organizer-features');
            if (featuresSection) {
              featuresSection.scrollIntoView({ behavior: 'smooth' });
            }
            setIsMenuOpen(false);
          }}>
            Features
          </div>
          <div className="organizer-nav-link" onClick={() => {
            const personasSection = document.querySelector('.organizer-personas');
            if (personasSection) {
              personasSection.scrollIntoView({ behavior: 'smooth' });
            }
            setIsMenuOpen(false);
          }}>
            Personas
          </div>
        </div>

        <div className="organizer-navbar-actions">
          <button 
            className="organizer-nav-btn-secondary"
            onClick={() => navigate('/organizer/login')}
          >
            Login
          </button>
          <button 
            className="organizer-nav-btn-primary"
            onClick={() => navigate('/organizer/register')}
          >
            Sign Up
          </button>
        </div>

        <button className="organizer-nav-toggle" onClick={toggleMenu}>
          {isMenuOpen ? '✕' : '☰'}
        </button>
      </div>
    </nav>
  );
};

export default OrganizerNavbar;

